import classNames from 'classnames'
import React, { useEffect } from 'react'

import useMediaQuery from 'common/hooks/useMediaQuery'
import * as twoDDisplayerSelectors from 'customizer/2dDisplayer/selectors'
import * as customizationSelectors from 'customizer/customization/selectors'
import { useDispatch, useSelector } from 'customizer/hooks'
import * as customizerStocksActions from 'customizer/stocks/actions'
import useThemeSettings from 'customizer/theme/useThemeSettings'
import withCustomizerRouter from 'customizer/withCustomizerRouter'
import BulkOrderModal from 'themes/common/components/bulkOrder/modal/BulkOrderModal'
import FontLoaderComponent from 'themes/common/components/FontLoaderComponent'
import QuoteModal from 'themes/common/components/quote/modal/QuoteModal'
import SummaryDrawerContextProvider from 'themes/common/components/summaryDrawer/context/SummaryDrawerContextProvider'

import DisplayerContainer from './displayer/components/DisplayerContainer'
import MobileDisplayerContainer from './displayer/components/MobileDisplayerContainer'
import QuestionPanel from './questionPanel/components/desktop/QuestionPanel'
import MobileQuestionPanel from './questionPanel/components/mobile/QuestionPanel'
import { stepsSelector } from './questionPanel/selectors'

import './customizer.scss'

interface CustomizerProps {
  startCustomization: (initialData: any) => void
  requestCss: () => void
  className?: string
  hideFinish?: boolean
  notify: (eventName: string) => void
}

export const Customizer = ({ startCustomization, className, hideFinish = false, notify }: CustomizerProps) => {
  const dispatch = useDispatch()
  const steps = useSelector(stepsSelector)
  const { panelPosition } = useThemeSettings('questionPanel')
  const { backgroundColor } = useThemeSettings('customizer')
  const isMobile = useMediaQuery('(max-width: 999px)')
  const isRenderCompleted = useSelector(twoDDisplayerSelectors.isRenderCompletedSelector)
  const productId = useSelector(customizationSelectors.productIdSelector)

  useEffect(() => {
    startCustomization(window.initialData)
  }, [startCustomization])

  useEffect(() => {
    if (productId) dispatch(customizerStocksActions.fetchStocks(productId))
  }, [productId])

  useEffect(() => {
    if (isRenderCompleted) notify('kickflipCustomizerFirstRenderCompleted')
  }, [isRenderCompleted])

  if (isMobile) {
    return (
      <SummaryDrawerContextProvider steps={steps}>
        <div className={classNames('customizer-page', className)}>
          <div className={`content panel-position-${panelPosition}`} aria-label="content">
            <MobileQuestionPanel />

            <div className="displayer-section" style={{ backgroundColor }}>
              <MobileDisplayerContainer hideFinish={hideFinish} />
            </div>

            <FontLoaderComponent />
            <BulkOrderModal />
            <QuoteModal />
          </div>
        </div>
      </SummaryDrawerContextProvider>
    )
  }

  return (
    <div className={classNames('customizer-page', className)}>
      <div className={`content panel-position-${panelPosition}`} aria-label="content">
        <QuestionPanel />

        <div className="displayer-section" style={{ backgroundColor }}>
          <DisplayerContainer hideFinish={hideFinish} />
        </div>

        <FontLoaderComponent />
        <BulkOrderModal />
        <QuoteModal />
      </div>
    </div>
  )
}

export default withCustomizerRouter(Customizer)
